'use client';

import { useIntl } from 'react-intl';
import { usePriceFormatter } from '@packages/shared/src/hooks/usePriceFormatter/usePriceFormatter';
import { TipBadge } from '../../TipBadge/TipBadge.client';
import { OutlinedCard } from '../../../../OutlinedCard/OutlinedCard';
import { CallToActionButton } from '../../CallToActionButton/CallToActionButton.client';

export type OutlinedWithBadgeProps = {
  /**
   * the single installment value from the calculation result as float (e.g. 13.37)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * open dialog handler
   */
  openInstallmentCalculatorHandler: () => void;
};

/**
 * Installment Calculator call to action component in minimal design
 *
 * component to promote the installment calculator in a minimal layout version
 *
 * */

export const OutlinedWithBadge = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  openInstallmentCalculatorHandler,
}: OutlinedWithBadgeProps) => {
  const { formatMessage } = useIntl();
  const formatPrice = usePriceFormatter('INSTALLMENTCALCULATOR');

  return (
    <OutlinedCard className="relative">
      <div className="flex flex-row flex-nowrap items-center gap-1.5">
        <TipBadge />
        <div>
          <div className="text-size-body-base font-bold">
            {formatMessage(
              {
                id: 'ic.promotion.OutlinedWithBadge.text',
                defaultMessage:
                  'Oder ab {value} mtl. in {installments, plural, one {# Rate} other {# Raten}}',
              },
              {
                value: formatPrice(singleInstallment, currency),
                installments: numberOfInstallments,
              },
            )}
          </div>
          <CallToActionButton
            className="text-left"
            openInstallmentCalculatorHandler={openInstallmentCalculatorHandler}
          />
        </div>
      </div>
    </OutlinedCard>
  );
};
